import apiClient from '../api/apiClient';
import SecureSessionService from '../session/SecureSessionService';
import { 
  UpdateUsernameRequest, 
  UpdateUsernameResponse
} from '../../types/username';

class UsernameService {
  /**
   * Update username via Okta profile update API
   */
  static async updateUsername(
    request: UpdateUsernameRequest
  ): Promise<UpdateUsernameResponse> {
    try {
      const session = SecureSessionService.getStoredSession();
      
      if (!session?.sessionId || !session?.userId) {
        throw new Error('Session not found or invalid');
      }

      const response = await apiClient.post<UpdateUsernameResponse>(
        `okta/updateProfile?sessionId=${session.sessionId}`,
        {
          newUserName: request.newUsername,
          isProfileUpdate: true
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default UsernameService;
